<template>
    <div class="search_content"  style="padding: 0px; width: 1200px;">

        <el-row class="tac"  :gutter="20">
            <el-col :span="5">
                <div class="search_content_left">

                    <el-menu
                            :default-active="default_load"
                            class="el-menu-vertical-demo"
                    >
                   <template v-for="(v,i) in videolist" >
                        <el-menu-item :key="i" :index="i+''" @click="playvideo(v,v.poster,i)" v-if="(lan=='ch' && v.cn!=1) || (lan=='en' && v.en!=1)">
                            <span slot="title">{{lan=="ch"?v.cn:v.en}}</span>
                        </el-menu-item>
                   </template>
                    </el-menu>
                </div>
            </el-col>
            <el-col :span="19">
                <div style="height: 420px; padding: 30px;background:#fff;margin:0 auto 20px;border-radius: 5px;text-align: center;" >
                    <video width="80%;" height="100%" controls="controls" style="margin: auto;text-align: center;" muted>
                    </video>
                </div>


                <div class="usage_content">
                    <el-card shadow="always" class="usage_shadow">
                    <div class="usage_explain">
                        <div class="usage_title">{{language.usageTitle}}</div>
                        <div class="pc">
                        <div style="margin-right: 10px">
                            <span style="width: 10px;height: 10px;background-color: #0f408a;border-radius: 50%;display: block"></span>
                        </div>
                        <div>{{language.chrome}}</div>
                        </div>
                        <div class="usage_download">
                        <div class="download_image" @click="download" style="cursor: pointer">
                            <img src="../../assets/chrome.png" style="width:89px;height:89px">
                        </div>
                        <div class="download" @click="download">
                            {{language.down}}
                        </div>
                        </div>
                        <div class="pc" style="margin-top: 40px">
                        <div style="margin-right: 10px">
                            <span style="width: 10px;height: 10px;background-color: #0f408a;border-radius: 50%;display: block"></span>
                        </div>
                        <div>{{language.appletCode}}</div>
                        </div>
                        <div class="usage_download">
                        <div class="download_image">
                            <img src="../../assets/img/28.jpg" style="width:130px;height:130px">
                        </div>
                        <div class="download">
                            {{language.weChatCode}}
                        </div>
                        </div>
                    </div>
                    </el-card>
                    <el-card shadow="always" style="margin-left: 20px" class="usage_shadow">
                    <div class="usage_explain">
                        <div class="usage_title">{{language.room}}</div>
                        <div class="pc">
                        <div style="margin-right: 10px">
                            <span style="width: 10px;height: 10px;background-color: #0f408a;border-radius: 50%;display: block"></span>
                        </div>
                        <div>{{language.exhibitor}}</div>
                        </div>
                        <div class="usage_download">
                        <div class="download_image">
                            <img src="../../assets/chrome.png" style="width: 89px;height: 89px">
                        </div>
                        </div>
                        <div class="pc" style="margin-top: 59px">
                        <div style="margin-right: 10px">
                            <span style="width: 10px;height: 10px;background-color: #0f408a;border-radius: 50%;display: block"></span>
                        </div>
                        <div>{{language.visitor}}</div>
                        </div>
                        <div class="usage_down_right">
                        <img src="../../assets/chrome.png" style="width: 110px;height: 110px;margin-top:10px;">
                        <img src="../../assets/img/28.jpg" style="margin-left: 50px;width: 130px;height: 130px">
                        </div>
                    </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import axios from "axios";
    import {language} from "../../language/get";
    import Cookie from "../../common/cookie";
    import reqest from "@/common/reqest";
    export default {
        props: ['inds','pasud'],
        name: "helpvideo",
        data() {
            return {
                default_load:'0',
                videolist:[],
                language: language(),
                lan: Cookie.get("lang"),
            }
        },
        methods:{
            playvideo(index,poster,i){
              // console.log("默认==" , i);
                let el = document.querySelector("video");
                el.setAttribute("poster",poster);
                el.setAttribute("src",index);
                el.setAttribute("src",this.lan=="ch"?index.video_src:index.video_src_en);
               // location.search = "?p="+i;
                el.play();
            },
            refPlaylist(req){
                 this.videolist = req;

                 //this.playvideo(this.inds)
                let el = document.querySelector("video");

                el.setAttribute("poster",req[0].poster);
                el.setAttribute("src",req[0].video_src);
                let d = el.play();
                if(d != undefined){
                    d.then(function () {
                        el.play()
                    }).catch(function () {

                    })
                }
               // this.default_load = (this.inds + 2)+"";
              this.default_load = String(this.inds);
                // console.log("默认==" + this.default_load);
            },

            download() {
                window.open("https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds")
            },
        },

        mounted() {

             var that = this;
            //  const vlist = sessionStorage.getItem("helpvideo");
            // if(!vlist) {
                axios.get(reqest.apiUrl+"/Home/video/getHelplist").then(function (req) {
                    that.refPlaylist(req.data);
                })
            // }else{
            //     that.refPlaylist(JSON.parse(vlist));
            // }
        },
        watch:{
            inds(o,v){
                console.log("31313e")
            }
        }
    }
</script>

<style scoped>
    .search_content_left{
        /*padding-top: 80px;*/
        padding-bottom: 50px;
        border-radius: 5px;
        background: #fff;
    }
    .search_content_left >>> .el-menu{
        background: #fff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .search_content_left >>> .is-active{
        background-color: #f2f2f2 !important;
        border-left: 2px solid #0071FE;
        color: #0071FE;
    }


    .usage_shadow {
        width: 460px;
        height: 643px;
        z-index: 9;
        float: left;
    }
    .usage_explain  {
        width: 312px;
        margin: auto;
        margin-top: 40px;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
    }
    .usage_title{
        color: #424242;
        font-size: 18px;
        font-weight: bold;
        font-family: MicrosoftYaHei-Bold;
    }
    .pc {
        color: #424242;
        font-size: 14px;
        font-family: MicrosoftYaHeiLight;
        margin-top: 20px;
        line-height: 19px;
        display: flex;
        align-items: center;
    }
    .download_image {
        width:130px;
        height:130px;
        margin: 20px auto;
    }
    .download {
        color: #424242;
        font-size: 14px;
        font-family: MicrosoftYaHeiLight;
        text-align: center;
        cursor: pointer;
    }
    .usage_down_right {
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 20px;
    }

</style>
